import React from 'react';
import { StepProps } from '../../types/form';
import { useReferenceData } from '../../context/ReferenceDataContext';
import { FormField } from '../ui/FormField';
import { ToggleGroup } from '../ui/ToggleGroup';
import { OptionMultiSelect } from '../ui/OptionMultiSelect';
export function LegalAICopilotStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  const {
    provinces,
    serviceCategories,
    isLoading
  } = useReferenceData();
  return <div className="space-y-6" data-id="element-105">
      <div data-id="element-106">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-107">Legal AI Copilot</h2>
        <p className="text-sm text-muted-foreground" data-id="element-108">
          Should users have access to the AI legal assistant?
        </p>
      </div>

      <FormField id="hasLegalAICopilot" label="Legal AI Copilot access" required error={errors.hasLegalAICopilot} data-id="element-109">
        <ToggleGroup value={formData.hasLegalAICopilot} onChange={val => updateFormData({
        hasLegalAICopilot: val
      })} error={!!errors.hasLegalAICopilot} data-id="element-110" />
      </FormField>

      {formData.hasLegalAICopilot && <div className="space-y-4" data-id="element-111">
          <FormField id="copilotProvinceIds" label="Which provinces or regions?" required error={errors.copilotProvinceIds} data-id="element-112">
            <OptionMultiSelect options={provinces} selectedValues={formData.copilotProvinceIds} onChange={vals => updateFormData({
          copilotProvinceIds: vals
        })} allSelected={formData.copilotAllProvinces} onSelectAll={all => updateFormData({
          copilotAllProvinces: all,
          copilotProvinceIds: []
        })} placeholder="Select provinces..." error={!!errors.copilotProvinceIds} loading={isLoading} data-id="element-113" />
          </FormField>

          <FormField id="copilotPracticeAreaIds" label="Which practice areas?" required error={errors.copilotPracticeAreaIds} data-id="element-114">
            <OptionMultiSelect options={serviceCategories} selectedValues={formData.copilotPracticeAreaIds} onChange={vals => updateFormData({
          copilotPracticeAreaIds: vals
        })} allSelected={formData.copilotAllPracticeAreas} onSelectAll={all => updateFormData({
          copilotAllPracticeAreas: all,
          copilotPracticeAreaIds: []
        })} placeholder="Select practice areas..." error={!!errors.copilotPracticeAreaIds} loading={isLoading} data-id="element-115" />
          </FormField>

          <FormField id="copilotMonthlyLimit" label="Monthly Question Limit Per User (Optional)" hint="Leave empty for unlimited." data-id="element-116">
            <input type="number" min="0" value={formData.copilotMonthlyLimit} onChange={e => updateFormData({
          copilotMonthlyLimit: e.target.value ? parseInt(e.target.value, 10) : ''
        })} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring" placeholder="e.g. 100" data-id="element-117" />
          </FormField>

          <div className="bg-muted/30 border border-border rounded-md p-4 space-y-3" data-id="element-118">
            <label className="flex items-center gap-3 cursor-pointer" data-id="element-119">
              <input type="checkbox" checked={formData.chatHistory} onChange={e => updateFormData({
            chatHistory: e.target.checked
          })} className="h-4 w-4 rounded border-input" data-id="element-120" />
              <span className="text-sm text-foreground" data-id="element-121">Can view past chat history</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer" data-id="element-122">
              <input type="checkbox" checked={formData.continuePreviousConversations} onChange={e => updateFormData({
            continuePreviousConversations: e.target.checked
          })} className="h-4 w-4 rounded border-input" data-id="element-123" />
              <span className="text-sm text-foreground" data-id="element-124">Can continue previous conversations</span>
            </label>
          </div>
        </div>}
    </div>;
}